module.exports = __webpack_public_path__ + "static/img/icon txzz2.65741f87.svg";